import { apiList, $axios } from '@/api'


export default {
    actions: {
        getSubmissionStatus(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.assign.getSubmissionStatus.method,
                    params: {
                        wsfunction: apiList.assign.getSubmissionStatus.moodle_method,
                        assignid: payload
                    }
                })
                    .then(resp => {
                        if (resp.data.errorcode) {
                            throw resp.data
                        }
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        getSubmissions(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.assign.getSubmissions.method,
                    params: {
                        wsfunction: apiList.assign.getSubmissions.moodle_method,
                        assignmentids: [payload]
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        triggerAssignViewEvent(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.assign.triggerViewEvent.method,
                    params: {
                        wsfunction: apiList.assign.triggerViewEvent.moodle_method,
                        assignid: payload
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        getAllAssigns(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.assign.getAllAssigns.method,
                    params: {
                        wsfunction: apiList.assign.getAllAssigns.moodle_method,
                        courseids: [payload]
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        saveSubmission(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.assign.saveSubmission.method,
                    data: {
                        wsfunction: apiList.assign.saveSubmission.moodle_method,
                        assignmentid: payload.id,
                        ...payload.data
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        sentSubmission(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.assign.sentSubmission.method,
                    params: {
                        wsfunction: apiList.assign.sentSubmission.moodle_method,
                        assignmentid: payload.id,
                        ...payload.data
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        }
    }
}
